// src/components/Eventos/EventsHeats/components/AbbreviationsLegend.jsx
import React from 'react';
import { Box, Typography, Grid, useTheme, useMediaQuery } from '@mui/material';
import CustomAccordion from '../../../CustomAccordion';
import { abbreviationDefinitions } from '../utils/constants';
import { getSpecialCodeColor, getFontSize } from '../utils/eventHelpers';

const AbbreviationsLegend = () => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));
  const isSm = useMediaQuery(theme.breakpoints.down('md'));
  const isMd = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <CustomAccordion
      title="Abreviaturas estándar"
      defaultExpanded={false}
    >
      <Box sx={{ p: 1 }}>
        <Typography variant="subtitle2" gutterBottom sx={{ mb: 2, color: theme.palette.primary.main }}>
          Nomenclaturas y abreviaturas utilizadas en resultados de atletismo:
        </Typography>
        
        <Grid container spacing={2}>
          {abbreviationDefinitions.map((def, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center',
                py: 0.5,
                borderBottom: '1px solid',
                borderColor: theme.palette.divider
              }}>
                <Box sx={{ 
                  minWidth: '50px', 
                  mr: 1,
                  fontWeight: 'bold',
                  color: getSpecialCodeColor(def.code, theme),
                }}>
                  {def.code}
                </Box>
                <Typography variant="body2" sx={{ fontSize: getFontSize(13, 1, isXs, isSm, isMd) }}>
                  {def.meaning}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </CustomAccordion>
  );
};

export default AbbreviationsLegend;